/*
 * NEXZ V2 — Collection/search analytics (Stage G)
 *
 * Same documented event-hook pattern as nexz-pdp.js: dispatches `nexz:*`
 * CustomEvents on `document`, no analytics destination wired here (a
 * later stage attaches a real listener). Reuses the real product-card
 * DOM (data-product-id, already present via product-card.liquid's own
 * `data-product-id` attribute) rather than adding new hooks per card.
 */
(function () {
  var EVENT_CONTRACT = ['view_item_list', 'select_item', 'search'];

  function nexzEmit(name, detail) {
    if (EVENT_CONTRACT.indexOf(name) === -1) return;
    document.dispatchEvent(new CustomEvent('nexz:' + name, { detail: detail || {}, bubbles: true }));
  }

  function cardIds(root) {
    return Array.prototype.map.call(root.querySelectorAll('product-card[data-product-id]'), function (el) {
      return el.getAttribute('data-product-id');
    });
  }

  function initGrid() {
    // results-list is Horizon's own native custom element, shared by
    // both sections/main-collection.liquid and sections/search-results
    // .liquid — no new attribute needed to find it.
    var root = document.querySelector('results-list');
    if (!root) return;

    var ids = cardIds(root);
    if (ids.length > 0) {
      nexzEmit('view_item_list', {
        listId: root.getAttribute('section-id') || undefined,
        productIds: ids,
      });
    }

    root.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('.product-card__link') : null;
      if (!link) return;
      var card = link.closest('product-card[data-product-id]');
      if (!card) return;
      var cards = Array.prototype.slice.call(root.querySelectorAll('product-card[data-product-id]'));
      var index = cards.indexOf(card);
      nexzEmit('select_item', {
        productId: card.getAttribute('data-product-id'),
        index: index,
      });
    });
  }

  function initSearch() {
    var root = document.querySelector('[data-nexz-search-performed]');
    if (!root || root.getAttribute('data-nexz-search-performed') !== 'true') return;
    nexzEmit('search', {
      query: root.getAttribute('data-nexz-search-query') || '',
      resultsCount: root.getAttribute('data-nexz-search-results-count') || '0',
    });
  }

  initGrid();
  initSearch();
})();
